/**
 * crudEditStore
 * 编辑页面共用逻辑以及部分子组件与父组件通讯
 */
import orderBackCountUtil from '../../../static/js/backCountUtils/orderBackCountUtil'
import priceControlBackCountUtil from '../../../static/js/backCountUtils/priceControlBackCountUtil'
import sheetsBackCountUtil from '../../../static/js/backCountUtils/sheetsBackCountUtil'
import ratioBackCountUtil from '../../../static/js/backCountUtils/ratioBackCountUtil'
import safeGoodsBackCountUtil from '../../../static/js/backCountUtils/safeGoodsBackCountUtil'
import objectUtil from '../../../static/js/objectUtil'

class CrudEditStore {
  constructor(crudEdit, initialState = {}, initialMutations, initialActions) {
    this.crudEdit = crudEdit

    //状态数据
    this.states = {
      formData: null,
      extendData: {
        rows: [],
        tableData: [], // 需求#5841，新增的
        length: 0,
        vue: null,
        clickData: null,
        isChange: false, //手术配货单切换的时候  是否值发生改变  未改变false  改变 true
        paramters: null, //记录表格数据通过接口获取时的请求参数
      },
      parentDataKey: 'parentFormData',
      //页面切换时不需缓存的数据
      provisional: {
        crudArrayOrderTableRef: null,
        tableValidate: null, //用于存放table中需要校验的列配置（由于table前端分页）
      },
    }

    //修改states的方法
    this.mutations = {
      //设置手术配货单切换的时候是否发生改变
      setIsChange(states, data) {
        this.states.extendData.isChange = data
      },
      setFormData(states, data) {
        this.states.formData = data
      },
      updateFormData(states, { response }) {
        this.crudEdit.getOfEditSuccess(response)
      },
      setExtendData(states, value, key, vueComponent, clickData) {
        if (key) {
          this.states.extendData[key] = value
        } else {
          this.states.extendData = value
        }
        if (vueComponent) {
          this.states.extendData.vue = vueComponent
        }
        if (clickData) {
          this.states.extendData.clickData = clickData
        }
      },
      setCrudArrayOrderTableRef(states, data) {
        this.states.provisional.crudArrayOrderTableRef = data
      },
      // 设置全局formData 数据保存的key
      setParentDataKey(states, data) {
        this.states.parentDataKey = data
      },
      //设置table中需要校验的列配置
      setTableValidate(states, data) {
        if (!states.provisional.tableValidate) {
          states.provisional.tableValidate = [data]
        } else {
          let tableValidate = states.provisional.tableValidate
          for (let item of tableValidate) {
            if (item.property == data.property) {
              item = Object.assign(item, data)
              return
            }
          }
          tableValidate.push(data)
        }
      },
      //刷新表格数据
      tableRefresh(states, flag) {
        this.crudEdit.updateTable(flag)
      },
      // 修复#32381，原因：formData.order.extend.edition_ 值不同，就会弹出提示：数据版本不一致,...
      updateFormDataForAll(_, { response }) {
        if (response?.isUpdateFormDataAll && response?.formData) {
          response.data.data = response.formData
          this.commit('updateFormData', { response })
        }
      },
      /** @name 到货通知单中，扫码验收后重新刷新表单页 */
      reload() {
        this.crudEdit.reload()
      },
      /**
       * @name 将返回数据添加到items中
       * @param {*} states
       * @param {*} param1
       * @param {*} [isUnshift=false] 是否从items的顶部添加数据
       */
      addItems(states, { response, responseData }, isUnshift = false) {
        const method = isUnshift ? 'unshift' : 'push'
        states.formData.items[method](...responseData)
        // 修复#32381
        this.commit('updateFormDataForAll', { response })

        this.commit('tableRefresh', true)
      },
      //返回数据根据_ID更新到items
      updataItemsBy_ID(states, { response, responseData }) {
        states.formData.items = objectUtil.arrMergeByKey(states.formData.items, responseData, '_ID')
        this.dispatch('orderBackCountUtil', 'orderDiscountsTotalFn', states.formData) //计算折扣金额总计
        // 修复#32381
        this.commit('updateFormDataForAll', { response })

        this.commit('tableRefresh', true)
      },
      //返回数据根据_ID更新到downItems，涉及到工具套包
      updataDownItemsBy_ID(states, { response, responseData }) {
        states.formData.downItems = objectUtil.arrMergeByKey(
          states.formData.downItems,
          responseData,
          '_ID'
        )
        // states.formData.items = tempArr.reduce((acc, cur) => [...acc, ...cur], [])
        this.dispatch('orderBackCountUtil', 'orderDiscountsTotalFn', states.formData) //计算折扣金额总计
        // 修复#32381
        this.commit('updateFormDataForAll', { response })

        this.commit('tableRefresh', true)
      },
      //根据parent和_ID更新items，如果是新增的行则新增到parent对应最后
      updateItemByParentAnd_ID(states, { response, responseData }) {
        const resMap = objectUtil.arrToMapByKey(responseData, 'parent')
        const itemsMap = objectUtil.arrToMapByKey(states.formData.items, 'parent')
        for (let [key, val] of itemsMap) {
          let temVal = objectUtil.arrMergeByKey(val, resMap.get(key), '_ID')
          itemsMap.set(key, temVal)
        }
        let tempArr = [...itemsMap.values()]
        states.formData.items = tempArr.reduce((acc, cur) => [...acc, ...cur], [])
        this.dispatch('orderBackCountUtil', 'orderDiscountsTotalFn', states.formData) //计算折扣金额总计
        // 修复#32381
        this.commit('updateFormDataForAll', { response })

        this.commit('tableRefresh', true)
      },
      //无源---根据库存id进行数量累加
      updataItemsBy_storageItemId(states, { response, responseData }) {
        let key =
          this.crudEdit.$store.state.user.system &&
          this.crudEdit.$store.state.user.system.code == 'LINK'
            ? 'goodsStore.storageItemId'
            : 'storageItem.id'
        states.formData.items = objectUtil.arrMergeByKey(states.formData.items, responseData, key)
        console.log(states.formData.items)
        this.dispatch('orderBackCountUtil', 'orderDiscountsTotalFn', states.formData) //计算折扣金额总计
        // 修复#32381 和 需求#5696 - 暂存后接口会更新表单并返回表单数据，需要将返回的表单数据刷新
        this.commit('updateFormDataForAll', { response })

        this.commit('tableRefresh', true)
      },
      //配货扫码消耗
      updateItemByParentAnd_IDForBack(states, { response, responseData }) {
        const resMap = objectUtil.arrToMapByKey(responseData, 'parent')
        const itemsMap = objectUtil.arrToMapByKey(states.formData.items, 'parent')
        for (let [key, val] of itemsMap) {
          let temVal = objectUtil.arrMergeByKey(val, resMap.get(key), '_ID')
          itemsMap.set(key, temVal)
        }
        let tempArr = [...itemsMap.values()]
        states.formData.items = tempArr.reduce((acc, cur) => [...acc, ...cur], [])
        // this.dispatch('orderBackCountUtil', 'orderDiscountsTotalFn', states.formData);//计算折扣金额总计
        // 修复#32381
        this.commit('updateFormDataForAll', { response })

        this.commit('tableRefresh', true)
      },
      // 手术配货（侧滑详情）:回库 一键消耗，根据待处理数量赋值消耗数量
      updateUseAmountForConsume(states) {
        states.formData.items.forEach((item) => {
          item.useAmount = item.completesAll.REMAIN.value ?? 0
        })
        this.commit('tableRefresh', true)
      },
      // 手术配货（侧滑详情）:回库 一键还回，根据待处理数量赋值回库数量
      updateUseAmountForBack(states) {
        states.formData.items.forEach((item) => {
          item.backAmount = item.completesAll.REMAIN.value ?? 0
        })
        this.commit('tableRefresh', true)
      },
      // 手术配货（侧滑详情）:回库 一键回库，根据出库数量赋值回库数量
      updateBackAmountByOutAmountForDetail(states) {
        states.formData.items.forEach((item) => {
          // 回库数量
          const backAmount = item.outAmount ?? 0
          // 消耗数量
          const useAmount = (item.outAmount ?? 0) - backAmount

          item.backAmount = backAmount
          item.useAmount = useAmount
        })

        this.commit('tableRefresh', true)
      },
      //一键删除空白行 （删除数量为null 的值）
      deleteNullAmount(states, _, vue) {
        const that = this

        vue.$pgMessage.confirm({
          title: '确认操作',
          content: '请确认是否‘一键删除数量空白行’?',
          sureBtnText: '删除',
          showCancelBtn: true,
          cancelBtnText: '取消',
          onOk: () => {
            const m = new Map()
            const items = states.formData.items
            const filterItems = function () {
              return items.filter((item) => {
                // 数量不为空不删除
                if (item.amount != null) {
                  return true
                }

                // 保护主行（主行需要核对它的所有从行的数量是否全部为空。是，则删除；否则，忽略）
                if (item.master) {
                  return (m.get(item.parent) ?? []).reduce((prev, cur) => {
                    return prev || cur.amount != null
                  }, false)
                }

                // 清空删除
                return false
              })
            }
            // 查找所有主行
            const masterRows = items.filter((item) => item.master)

            masterRows.forEach((row) => {
              m.set(
                row.parent,
                items.filter((d) => d.parent === row.parent)
              )
            })

            // 更新
            states.formData.items = filterItems()
            that.commit('tableRefresh', true)
          },
        })
      },
    }
    //操作方法
    this.actions = {
      crudArrayOrderSort() {
        return false
      },

      //销售确认退货单更新页面的数据
      changeFormData(context, data) {
        this.crudEdit.getOfEditSuccess(data)
      },
      //手术配货页面
      scanModelOne(_, { vue }) {
        console.log('扫码确认后置模式')
        try {
          let flag = true
          const self = vue?.$parent?.$parent?.$parent?.$parent

          if (vue.model) {
            let resError = null
            // 校验优联-重复原厂序列号 或者 灵科-重复添加
            resError = vue.validRepeatForSerial(self)

            if (!resError) {
              switch (vue.model) {
                /** @name 录入模式：匹配到单据明细行，录入扫码信息和累加数量，不同批号、生产日期等则拆行（适配页面：待处理-来自采购订单等） */
                case 'import':
                  flag = vue.modelImport(self)
                  break
                /** @name 匹配模式：匹配到单据明细行，匹配并累加数量，如果未匹配成功则匹配最近的商品和批号相同进行拆行（适配页面：待处理-来自收货通知单等） */
                case 'checkoutAmount':
                  flag = vue.modelCheckoutAmount(self, true)
                  break
                default:
                  resError = '配置模式的模式不正确'
                  break
              }
            }

            if (resError) throw new Error(resError)

            // 重置状态为 create
            vue.scanStatus = 'create'
            // 可保存
            self.isSave = true
          }

          return flag
        } catch (error) {
          console.warn('-------------- error: ', error?.message)
          vue.updateWarnOrErrorMessage(error?.message ?? '对不起！发生未知异常', 'error')
        }
      },
      //触发单据类的反算
      orderBackCountUtil(context, field, ...args) {
        if (orderBackCountUtil[field] && typeof orderBackCountUtil[field] == 'function') {
          if (field == 'attrs.valueText.discount') {
            this.dispatch('updatePriceItem', field, ...args)
          } else {
            return orderBackCountUtil[field](...args)
          }
        }
      },
      //触发价格管理的反算
      priceControlBackCountUtil(context, field, ...args) {
        if (
          priceControlBackCountUtil[field] &&
          typeof priceControlBackCountUtil[field] == 'function'
        ) {
          return priceControlBackCountUtil[field](...args)
        }
      },
      //触发打印侧滑表格反算 4021 lqn 配送单-打印标签
      sheetsBackCountUtil(context, field, ...args) {
        if (sheetsBackCountUtil[field] && typeof sheetsBackCountUtil[field] == 'function') {
          return sheetsBackCountUtil[field](...args)
        }
      },
      ratioBackCountUtil(context, field, ...args) {
        if (ratioBackCountUtil[field] && typeof ratioBackCountUtil[field] == 'function') {
          return ratioBackCountUtil[field](...args)
        }
      },
      //触发安全库存设置中添加商品的反算
      safeGoodsBackCountUtil(context, field, ...args) {
        if (safeGoodsBackCountUtil[field] && typeof safeGoodsBackCountUtil[field] == 'function') {
          return safeGoodsBackCountUtil[field](...args)
        }
      },
      //用于判断计算工具类中是否存在该方法
      //utilName计算工具类的名字
      ifBackCountUtil(context, utilName, key) {
        if (utilName == 'orderBackCountUtil' && orderBackCountUtil[key]) {
          return true
        } else if (utilName == 'priceControlBackCountUtil' && priceControlBackCountUtil[key]) {
          return true
        } else {
          return false
        }
      },
      // 触发价格组变化后的价格更新, 解决 线下采购订单 没有organization也可以添加商品(21779)
      updateForPriceRange(context, formData, crudEditOrderRef) {
        crudEditOrderRef.$axios
          .post(this.crudEdit.batchPriceUrl, formData)
          .then((res) => {
            crudEditOrderRef.getOfEditSuccess(res)
            crudEditOrderRef.updateTable()
          })
          .catch((err) => {
            console.error(err)
          })
      },
      //修改赠品为是时重新获取价格信息
      updatePriceItem(context, field, itemData, formData) {
        if (
          formData.items &&
          formData.items.length > 0 &&
          objectUtil.getValueByPath(itemData, field, '') !== 'gift'
        ) {
          let tempForm = Object.assign({}, formData)
          tempForm.items = [itemData]
          let tempID = itemData._ID
          console.info('tempID', tempID)
          this.crudEdit.$axios
            .post('rest/main/order/bill/batchPrice', tempForm)
            .then((res) => {
              if (res && res.data && res.data.code == 200 && res.data.data && res.data.data.items) {
                for (let i = 0; i < formData.items.length; i++) {
                  if (formData.items[i]._ID == tempID) {
                    console.info('iiiii', i)
                    let temItem = res.data.data.items[0]
                    temItem._ID = objectUtil.createID()
                    formData.items[i] = temItem
                    console.info('formData.items', formData.items)
                    this.dispatch('orderBackCountUtil', 'orderDiscountsTotalFn', formData, temItem)
                    this.crudEdit.broadcast('panguTable', 'on-table-change')
                    break
                  }
                }
              }
            })
            .catch((err) => {
              console.error(err)
            })
        } else {
          return orderBackCountUtil[field](itemData, formData)
        }
      },
      /**
       * @name 设置为自定义数量
       * @description #6428 【优联-web-云南骨科】制单时表格中的数量字段操作优化
       * 【设置为自定义数量】
       * 1. 用户执行时，确认提示框中有两种操作：全部设置、仅设置当前为空的数量。
       * 2. 默认值为1
       */
      updateItemAmountToCustom({ states }, param) {
        let formData = states.formData
        if (!formData || !formData.items || formData.items.length == 0) return

        let items = formData.items
        let len = items.length

        //针对amount 和plan 有可能不一样 需要对参数进行配置
        let { amount = 'amount', value, mode } = param
        for (let i = 0; i < len; i++) {
          // 自定义数量,有值并大于0的时候，才赋值。否则判读未无计划数量。不赋值
          if (value) {
            if (value && ((mode === 'sure-right' && !items[i][amount]) || mode === 'sure')) {
              items[i][amount] = value
              //换算比例,计算并填写items[i].amountDisplay
              this.dispatch('orderBackCountUtil', 'amountBack', formData.items[i], formData)
            }
          }
        }
        this.crudEdit.broadcast('panguTable', 'on-table-change')
      },
    }

    //初始赋值自定义state
    for (let prop in initialState) {
      if (
        Object.prototype.hasOwnProperty.call(initialState, prop) &&
        Object.prototype.hasOwnProperty.call(this.states, prop)
      ) {
        this.states[prop] = initialState[prop]
      }
    }

    //初始赋值自定义mutations
    for (let prop in initialMutations) {
      if (Object.prototype.hasOwnProperty.call(initialMutations, prop)) {
        this.mutations[prop] = initialMutations[prop]
      }
    }

    //初始赋值自定义actions
    for (let prop in initialActions) {
      if (Object.prototype.hasOwnProperty.call(initialActions, prop)) {
        this.actions[prop] = initialActions[prop]
      }
    }
  }

  commit(name, ...args) {
    const mutations = this.mutations
    if (mutations[name]) {
      mutations[name].apply(this, [this.states].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }

  dispatch(name, ...args) {
    const actions = this.actions
    if (actions[name]) {
      return actions[name].apply(this, [this].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }
}

export default CrudEditStore
